module.exports = __webpack_public_path__ + "static/img/3.8007209.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/sp/3.png
// module id = bZrC
// module chunks = 0